/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioVersionStatus {
    DRAFT = 'DRAFT',
    HISTORIC = 'HISTORIC',
    LIVE = 'LIVE'
}


export function instanceOfInternalApiScenarioVersionStatus(value: any): boolean {
    for (const key in InternalApiScenarioVersionStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioVersionStatus, key)) {
            if (InternalApiScenarioVersionStatus[key as keyof typeof InternalApiScenarioVersionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioVersionStatusFromJSON(json: any): InternalApiScenarioVersionStatus {
    return InternalApiScenarioVersionStatusFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionStatus {
    return json as InternalApiScenarioVersionStatus;
}

export function InternalApiScenarioVersionStatusToJSON(value?: InternalApiScenarioVersionStatus | null): any {
    return value as any;
}

export function InternalApiScenarioVersionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionStatus {
    return value as InternalApiScenarioVersionStatus;
}

